import gqlTagGira from 'graphql-tag';

export const ISSUE_DETAILS_QUERY = gqlTagGira`
    query jira_deploymentFrequencyReportDeploymentDetails_issueDetails_Query($jql: String, $first: Int!) {
        issues(first: $first, jql: $jql) {
            nodes {
                id
                issuekey {
                    stringValue
                }
                issuetype {
                    iconUrl
                }
                issuekey {
                    stringValue
                }
                summary {
                    textValue
                }
                assignee {
                    userValue {
                        displayName
                        avatarUrl
                    }
                }
                status {
                    name
                    statusCategoryId
                }
            }
        }
    }
`;
